<div class="dtf-accountdetails">
  <!--This is a name used for styling from the dtf-accountdetailpage.scss-->
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage"></div>

  <div *ngIf="(this.bodyLoaded)" class="mbfs-payoff-quote-spinner">

    <!--Default page to load while waiting for Redirection to Classic-->
    <section class="mbfs-home-hero"
      style="background-image: url(/static/assets/img/dtf-assets/images/redesign/mbfs_top_image_and_tint.jpg);">
      <section class="mbfs-home-hero__header">
        <h2 class="mbfs-home-hero__header-subtitle">
          {{ 'LoaderPages.BannerHeader' | translate }}
        </h2>
        <p class="mbfs-home-hero__header-text-demi">
          {{ 'LoaderPages.Loading' | translate }}
        </p>

        <!--Spinner-->
        <div class="mbfs-loading-spinner-overlay"></div>
        <div class="mbfs-loading-spinner"> </div>
      </section>
    </section>
  </div>

  <div class="container_dashboard">
    <h4 class="dtfbrochures__header_dark">{{ 'Invoice.Header' | translate }}</h4>
    <div class="dtfbrochures__containerlong">
      <div class="row4">
        <div class="dynamicflexbox">
          <section class="section">
            <div class="section__item section__item--start">
              <h4 class="dtfbrochures__header5">{{ 'Dashboard.NumAccounts' | translate }}</h4>
              <h3 class="dtfbrochures__header6">{{this.recAccCount}}</h3>
            </div>
            <div class="section__item section__item--end">
              <h4 class="dtfbrochures__header5">{{ 'Dashboard.CurrentDue' | translate }}</h4>
              <h3 class="dtfbrochures__header6">${{this.totalDue}}</h3>
            </div>
          </section>
        </div>
      </div>
    </div>
  

 
    <div class="padding-main-divcls && cardlike" id="agrrement-section" *ngIf="!this.bodyLoaded  && !isCanadaPortal">
      <div class="row">
        <div class="col-sm-2">
          <mat-form-field class="w-100" appearance="outline">
            <mat-select name="statementPeriod" placeholder="{{ 'Invoice.StatePeriod' | translate }}"
              (selectionChange)="onStatementChange()" [(ngModel)]="displayValue">
              <mat-option *ngFor="let month of statementMonths" [value]="month.value">
                {{month.value}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-1">
          <p style="margin-top:15px;">OR</p>
        </div>
        <div class="col-sm-3">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>{{ 'Invoice.DateRange' | translate }}</mat-label>
            <mat-date-range-input [min]="minDate" [max]="currentDate" [rangePicker]="dateRangePicker">
              <input matStartDate readonly (ngModelChange)="clearEndDate($event)" [(ngModel)]="dateRangeStart"/>
              <input matEndDate readonly [(ngModel)]="dateRangeEnd" (dateChange)="dateRangeChange()" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="dateRangePicker">
            </mat-datepicker-toggle>
            <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
          </mat-form-field>
        </div>
        <div class="col-sm-3">
          <button class="w-75" type="submit" (click)="onDownloadClick('.xlsx')" class="mbfs-button" style="margin-top:15px;">{{ 'Invoice.ExcelButton' | translate }}</button>
        </div>
        <div class="col-sm-3">
          <button type="submit" (click)="onDownloadClick('.pdf')" class="mbfs-button" style="margin-top:15px;">{{ 'Invoice.PDFButton' | translate }}</button>
        </div>
      </div>
    </div>
    <!--CA-->
    <div class="padding-main-divcls && cardlike" id="agrrement-section" *ngIf="!this.bodyLoaded  && isCanadaPortal">
      <div class="row">
        <div class="col-sm-2">
          <mat-form-field class="w-100" appearance="outline">
            <mat-select name="statementPeriod" placeholder="{{ 'Invoice.StatePeriod' | translate }}"
              (selectionChange)="onStatementChange()" [(ngModel)]="displayValue">
              <mat-option *ngFor="let month of statementMonths" [value]="month.value">
                {{month.value}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-1">
          <p style="margin-top:15px;">{{ 'LoginModal.OR' | translate }}</p>
        </div>
        <div class="col-sm-3">
          <mat-form-field class="w-100" appearance="fill">
            <mat-label>{{ 'Invoice.DateRange' | translate }}</mat-label>
            <mat-date-range-input [min]="minDate" [max]="currentDate" [rangePicker]="dateRangePicker">
              <input matStartDate readonly (ngModelChange)="clearEndDate($event)" [(ngModel)]="dateRangeStart"/>
              <input matEndDate readonly [(ngModel)]="dateRangeEnd" (dateChange)="dateRangeChange()" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="dateRangePicker">
            </mat-datepicker-toggle>
            <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
          </mat-form-field>
        </div>
        <div class="col-sm-3">
          <button class="w-75" type="submit" (click)="onDownloadClick('.xlsx')" class="mbfs-button" style="margin-top:15px;">{{ 'Invoice.ExcelButton' | translate }}</button>
        </div>
        <div class="col-sm-3">
          <button type="submit" (click)="onDownloadClick('.pdf')" class="mbfs-button" style="margin-top:15px;">{{ 'Invoice.PDFButton' | translate }}</button>
        </div>
      </div>
    </div>

      <p style="margin-left: 1%;"><b>{{ 'Invoice.RowCount' | translate }} {{this.rowCount}}</b></p>
      <div *ngIf="(!this.invoiceLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
        <!--Spinner on Login Load-->
        <div class="demo-container">
          <span>{{ 'Invoice.Loading' | translate }}</span>
          <div class="progress-bar">
            <div class="progress-bar-value"></div>
          </div>
        </div>
        <br>
      </div>
    <div class="tile">
    <mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z15" matSort>
      
      <ng-container matColumnDef="{{column.name}}" *ngFor="let column of initColumns; last as isLast; first as isFirst;">

        <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef  >
         <div *ngIf="isFirst"> 
          <mat-checkbox  [ngClass]="{'white-border': !isChecked}" (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"  >
       </mat-checkbox></div>
          <div *ngIf="!isFrench"> {{column.display}}</div>
          <div *ngIf="isFrench"> {{column.displayFR}}</div>
        </mat-header-cell>
         <mat-cell *matCellDef="let element">
          <div *ngIf="isFirst"   > <mat-checkbox (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(element) : null"
          [checked]="selection.isSelected(element)" >
       </mat-checkbox></div>
          <span class="mobile-label">
            <div *ngIf="!isFrench"> {{column.displayMobile}} :</div>
            <div *ngIf="isFrench"> {{column.displayMobile}} :</div>
          </span>
          <div *ngIf="column.dispFormat=='currency'">
            <!--Formats Currency Columns-->
            {{element[column.name] | currency:'USD':true:'1.2-2'}}
          </div>
          <div *ngIf="column.dispFormat==''">
            <!--Formats String Columns-->
            {{element[column.name]}}
          </div>
          <div *ngIf="column.dispFormat=='tooltip'">
            <div matTooltip="{{element.dba_fao_billingAdd}}">{{element[column.name] | slice:0:-3 }} /{{ element[column.name] | slice:-2}}</div>
          </div>
          <div *ngIf="column.dispFormat=='date'">
            <!--Formats date Columns-->
            {{element[column.name] | date:'MM/dd/yyyy'}}
          </div>
          <div>{{booleanReset()}}</div> <!--Resets boolean for icon duplication-->
          <div style="display: flex; gap: 40px;">
      <div *ngIf="column.dispFormat=='img'" style="display: flex;  gap: 10px;">
         <mat-icon *ngIf="!this.PDFBool" style="margin-left: 10px" matTooltip="Download pdf">
            <div>{{booleanCheck('.pdf')}}</div> <!--turns on boolean for icon duplication-->
               <img (click)="onIconClick(element.invoiceNumber,'.pdf')" matSuffix class="example-form-img"
            src="static/assets/img/dtf-assets/images/DTF_Icons/pdf.png">
              </mat-icon>
             <mat-icon *ngIf="element.invoiceType!='A' && !this.XLSXBool" style="margin-right: 10px"  matTooltip="Download Xlsx">
            <div>{{booleanCheck('.xlsx')}}</div>
              <img (click)="onIconClick(element.invoiceNumber,'.xlsx')" matSuffix class="example-form-img"
             src="static/assets/img/dtf-assets/images/DTF_Icons/excel-icon.png">
              </mat-icon>
             </div></div>
        </mat-cell>
      </ng-container>
      
      <ng-container matColumnDef="invoiceRes">
        <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
          [attr.colspan]="displayedColumns.length">
          <div class="example-element-detail" [@detailExpand]="element == invoiceRes ? 'expanded' : 'collapsed'">
            <div class="example-element-diagram">
              <!-- <div class="example-element-description">
                <a class="link2">{{element.dba_fao_billingAdd}}</a>
              </div> -->
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"
        [class.example-expanded-row]="invoiceRes === element"
        (click)="invoiceRes = invoiceRes === element ? null : element">
      </mat-row>
      <mat-row *matRowDef="let row; columns: ['invoiceRes']" class="example-detail-row"></mat-row>

      <!-- Row shown when there is no matching data. -->
     <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" *ngIf="!InvoiceFound" colspan="4"><b>{{this.InvoiceErrorDesc}}</b></td>
      </tr>
    </mat-table>
    <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
  </div>
  <br>  
  <footer id="mbfs-footer">
      <div role="contentinfo">
        <div class="mbfs-copyright">
          <p class="paragraph1"> {{ 'Amortization.Disclaimer3' | translate }} </p>
        </div>
      </div>
    </footer>
</div>